import React, { useRef, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const RenderCode = ({ length = 6 }) => {
  const { register, setValue, getValues } = useFormContext();
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const moveFocus = (index) => {
    inputRefs.current[index]?.focus();
  };

  const handleChange = (index, value) => {
    const digit = (value || '').replace(/\D/g, '').slice(0, 1);

    setValue(`codeInputs.${index}`, digit, {
      shouldValidate: true,
      shouldDirty: true
    });

    if (digit && index < length - 1) {
      moveFocus(index + 1);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      const current = getValues(`codeInputs.${index}`);
      if (current) {
        setValue(`codeInputs.${index}`, '', { shouldValidate: true, shouldDirty: true });
        e.preventDefault();
      } else if (index > 0) {
        setValue(`codeInputs.${index - 1}`, '', { shouldValidate: true, shouldDirty: true });
        moveFocus(index - 1);
        e.preventDefault();
      }
    }
  };

  const handlePaste = (index, e) => {
    const text = e.clipboardData.getData('text').replace(/\D/g, '');
    if (!text) return;
    e.preventDefault();

    const chars = text.slice(0, length - index).split('');
    chars.forEach((ch, i) => {
      setValue(`codeInputs.${index + i}`, ch, { shouldValidate: true, shouldDirty: true });
    });

    const nextIndex = Math.min(index + chars.length, length - 1);
    moveFocus(nextIndex);
  };

  return (
    <div className="auth-row">
      {Array.from({ length }).map((_, index) => {
        const fieldName = `codeInputs.${index}`;
        const { ref, ...field } = register(fieldName);

        return (
          <div className="auth-input-wrapper" key={index}>
            <input
              {...field}
              ref={(el) => {
                ref(el);
                inputRefs.current[index] = el;
              }}
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-control"
              maxLength={1}
              autoFocus={index === 0}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              onPaste={(e) => handlePaste(index, e)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default RenderCode;
